import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import {
  setWorkflowData as setWorkflowDataAction,
  setWorkflowResourceType,
  setReviewData as setReviewDataAction,
} from "../reducers/Workflows";

export const setWorkflowData = setWorkflowDataAction;
export { setWorkflowResourceType };
export const setReviewData = setReviewDataAction;

export function fetchWorkflowData({ workflowId }) {
  return async (dispatch) => {
    const data = { id: workflowId };
    const response = await axiosWrapper.post(`${getBackendUrl()}/workflows/getWorkflowData`, data);

    if (response.data.status) {
      dispatch(setWorkflowData(response.data.result));
    }
  };
}

export function fetchReviewData({ reviewId }) {
  return async (dispatch) => {
    const data = { _id: reviewId };

    const response = await axiosWrapper.post(`${getBackendUrl()}/reviews/getReviewData`, data);

    if (response.data.status) {
      dispatch(setReviewData(response.data.result));
    }
  };
}
